import React from 'react';
import RecordSourceWrapperIcon from 'screens/Applications&WorkOrders/Components/DetailsTabs/components/DetailsTab/components/RecordSourceWrapperIcon';
import { RECORD_SOURCE_ICON_SIZE } from 'screens/Applications&WorkOrders/Components/DetailsTabs/components/DetailsTab/constant/recordSourceIconSize';

const InvoiceIcon: React.FC = () => {
  return (
    <RecordSourceWrapperIcon className="bg-neutral-60">
      <svg
        aria-hidden="true"
        xmlns="http://www.w3.org/2000/svg"
        width={RECORD_SOURCE_ICON_SIZE.width}
        height={RECORD_SOURCE_ICON_SIZE.height}
        viewBox="0 0 13 13"
        fill="none"
      >
        <path
          d="M7.29134 1.04102H3.12467C2.55176 1.04102 2.08301 1.50977 2.08301 2.08268V10.416C2.08301 10.9889 2.55176 11.4577 3.12467 11.4577H9.37467C9.94759 11.4577 10.4163 10.9889 10.4163 10.416V4.16602L7.29134 1.04102ZM3.12467 10.416V2.08268H6.77051V4.16602H9.37467V10.416H3.12467ZM5.72884 9.89518H6.77051V9.37435H7.29134C7.5778 9.37435 7.81217 9.13997 7.81217 8.85352V7.29102C7.81217 7.00456 7.5778 6.77018 7.29134 6.77018H5.72884V6.24935H7.81217V5.20768H6.77051V4.68685H5.72884V5.20768H5.20801C4.92155 5.20768 4.68717 5.44206 4.68717 5.72852V7.29102C4.68717 7.57747 4.92155 7.81185 5.20801 7.81185H6.77051V8.33268H4.68717V9.37435H5.72884V9.89518Z"
          fill="white"
        />
      </svg>
    </RecordSourceWrapperIcon>
  );
};

export default InvoiceIcon;
